export const university = {
  rexmonster: [
    {
      id: "ab9cbbe5-2fb9-4313-80bd-3292a853b800",
      text: "Mumbai University",
    },
    {
      id: "7f4b5a53-e9c2-43d3-861b-c483318458cd",
      text: "Anna University, Chennai",
    },
    {
      id: "5b1ba5b9-f8bd-42da-9428-311351f85839",
      text: "Savitribai Phule Pune University (SPPU)",
    },
    {
      id: "e643a1c4-e7b7-432e-afb4-8675b232ad3f",
      text: "Delhi University",
    },
    {
      id: "b5d7c014-6f61-4c62-808b-f501b97066a9",
      text: "University of Madras",
    },
    {
      id: "81f80175-8225-4852-9ca7-5de99ea8b05c",
      text: "Pune University",
    },
    {
      id: "952be7c8-6f1e-482c-8c77-502149eb3866",
      text: "Osmania University",
    },
    {
      id: "ace3a495-dba2-4f1d-b60f-41c99f217570",
      text: "Bangalore University",
    },
    {
      id: "9aba6def-24c5-11eb-b0c6-3ca82aea621c",
      text: "Visvesvaraya Technological University (VTU)",
    },
    {
      id: "f8882747-e04f-4489-95e5-4d890187bd26",
      text: "Indira Gandhi National Open University (IGNOU)",
    },
  ],
  monstergulf: [
    {
      id: "46df6c4d-45e4-4bfc-8e52-cbd9b7b08eda",
      text: "Cairo University",
    },
    {
      id: "d15bcb70-22c3-4d46-8c0f-8add8fa2ad51",
      text: "Lebanese University",
    },
    {
      id: "b03a2038-3732-400e-80e6-a0df31aed6ea",
      text: "Alexandria University",
    },
    {
      id: "3a72297c-ef84-4f8e-b842-438b2c641119",
      text: "Ain Shams University",
    },
    {
      id: "705a0fc5-8cd3-4bc2-a91d-ca9aad44f6ad",
      text: "Mansoura University",
    },
    {
      id: "c7215697-164b-4923-b1a4-e30ed98fe46d",
      text: "Helwan University Cairo",
    },
    {
      id: "2a5ee332-d925-42b8-949b-77b54fa5e0f0",
      text: "Zagazig University",
    },
    {
      id: "019e9b14-73f3-47d7-a2a5-2fafa1daff84",
      text: "Beirut Arab University",
    },
    {
      id: "5f780747-c996-414d-bea9-14901a60dd85",
      text: "Lebanese International University",
    },
    {
      id: "6c224458-bca9-4e3f-96c1-c9369273ca9c",
      text: "University of Khartoum",
    },
  ],
  monstermalaysia: [
    {
      id: "6edc48ad-5a59-4ced-9206-30aaa7ce62ba",
      text: "Universiti Teknologi Mara (UiTM)",
    },
    {
      id: "22945878-cea0-432d-9efa-c857dbf86d90",
      text: "Universiti Teknologi Malaysia",
    },
    {
      id: "d16ba0bb-76ed-4d0b-9d69-eeb3a7153c45",
      text: "Universiti Sains Malaysia",
    },
    {
      id: "0216b66f-40ae-428f-becf-73ad667b0617",
      text: "Multimedia University",
    },
    {
      id: "7a590b2c-b543-49c6-a276-5286436d7317",
      text: "Universiti Teknikal Malaysia Melaka",
    },
    {
      id: "3ba63210-7930-4aee-ba1b-680e33341b87",
      text: "Universiti Putra Malaysia (UPM)",
    },
    {
      id: "20627e1e-3c00-412d-afc4-5e1fee3dabea",
      text: "Tunku Abdul Rahman College (TARC)",
    },
    {
      id: "a409f603-2605-460e-b99e-aa44bcb45cc4",
      text: "University of Malaya",
    },
    {
      id: "be44132b-5b6a-4ea6-b5cf-8153c8207ca6",
      text: "Universiti Utara Malaysia (UUM)",
    },
    {
      id: "b487cc8f-3bdc-46b9-9e71-fad28dca0be6",
      text: "Universiti Tun Hussein Onn Malaysia",
    },
  ],
  monsterphilippines: [
    {
      id: "ec6c2686-4da0-433c-8744-a50eb1ee9d99",
      text: "Polytechnic University of the Philippines",
    },
    {
      id: "6500f8e7-f11d-450f-acce-cd366a1a76db",
      text: "Bulacan State University",
    },
    {
      id: "32ea569c-a188-4eeb-acdf-89b28c8d1abb",
      text: "Batangas State University",
    },
    {
      id: "caf3678c-2edd-4541-aed1-8a3360d876ae",
      text: "Cavite State University",
    },
    {
      id: "ebfc69f8-1d0c-496e-a957-b134e791bcd1",
      text: "Rizal Technological University",
    },
    {
      id: "f6c24c6d-ce29-4c64-a976-87d61cbf04e2",
      text: "University of the Philippines",
    },
    {
      id: "04fb49c0-3773-4032-a03d-6ca4411627d5",
      text: "University of Santo Tomas, Manila",
    },
    {
      id: "298680d3-e0fb-4ae9-b7a7-24082d073b20",
      text: "Adamson University",
    },
    {
      id: "237a4237-9483-4d25-8a66-5281a1ef1a7d",
      text: "University of the East",
    },
    {
      id: "2815e99e-72ac-4db7-848f-9ace0274339a",
      text: "Far Eastern University, Makati",
    },
  ],
  monstersingapore: [
    {
      id: "55561b18-2108-11ec-9621-0242ac130002",
      text: "Singapore Polytechnic",
    },
    {
      id: "55561064-2108-11ec-9621-0242ac130002",
      text: "Republic Polytechnic",
    },
    {
      id: "55562d42-2108-11ec-9621-0242ac130002",
      text: "Temasek Polytechnic",
    },
    {
      id: "373cb259-3b57-11e9-a89e-70106fbef856",
      text: "National University of Singapore (NUS)",
    },
    {
      id: "555606b4-2108-11ec-9621-0242ac130002",
      text: "Nanyang Polytechnic",
    },
    {
      id: "55560b00-2108-11ec-9621-0242ac130002",
      text: "Ngee Ann Polytechnic",
    },
    {
      id: "3727eb45-3b57-11e9-a89e-70106fbef856",
      text: "Nanyang Technological University",
    },
    {
      id: "55561a5a-2108-11ec-9621-0242ac130002",
      text: "Singapore Management University",
    },
    {
      id: "55561dc0-2108-11ec-9621-0242ac130002",
      text: "Singapore University of Social Sciences",
    },
    {
      id: "e979c012-ee99-42e9-84ac-5051c9442d34",
      text: "PSB Academy",
    },
  ],
};
